import createStore from '../../../../redux/factories/crud/crudFactory';
import masterDataReducers from './reducers';
import masterDataSaga from './saga';

const {actionTypes, actions, reducers, sagas} = createStore('api/v2/master-view');

export {actionTypes, actions, reducers, sagas, masterDataReducers, masterDataSaga};
